import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel } from '../api/responseModel';
import { mapAuditoriaItem } from './auditoriaDto';

const INDEX_PATH = '/api/aud/Index';

export function listAuditoria(query = { page: 1, pageSize: 25 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => {
    const paged = unwrapPagedResponseModel(data);
    return {
      ...paged,
      items: (paged.items ?? []).map(mapAuditoriaItem),
    };
  });
}
